import { AxiosRequestConfig } from 'axios';
import { IBRMRule } from 'src/common/api/brm/brm-utils';
import { ILoginUser } from 'src/common/interfaces/dtos/ILoginUser';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

export function getApproval(
  transactionId: string,
  brmRule: IBRMRule,
  creds?: ILoginUser,
): Promise<void> {
  brmRule.data = creds;
  const axiosConfig: AxiosRequestConfig = {
    url: `/transaction-management/transactions/${transactionId}/approval`,
    method: 'PUT',
    data: brmRule,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: false,
    sessionId: creds?.sessionId,
  };

  return emeraldRequest(emeraldRequestParams);
}
